import { MRT_ColumnDef } from 'mantine-react-table'
import React from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import ProvinceDetail from 'src/containers/ProvinceDetail'

function ProvinceDetailPage() {
	const params = useParams()
	const { name } = params
	const navigate = useNavigate()

	const columns: MRT_ColumnDef[] = [
		{
			accessorKey: 'name',
			header: 'Name',
		},
		{
			accessorKey: 'last_login_at',
			header: 'Last login at',
		},
	]
	const fields = [
		{
			value: 'name',
			label: 'Name',
		},
	]

	const handleDetail = (row) => {
		navigate(`/users/${row?.original?.id}`)
	}

	return (
		<ProvinceDetail
			name={name}
			columns={columns}
			fields={fields}
			handleDetail={handleDetail}
		/>
	)
}

export default React.memo(ProvinceDetailPage)